// extracted by mini-css-extract-plugin
export default {"actions":"PresenterActions_actions__tJOed"};